<template>
    <dialogo-opciones-componente dialogo-titulo="Lugar de fabricación" descripcion="Es la distancia que recorrerá el
    material desde su fabricación hasta su puesta en obra">
        <template v-slot:titulo>
            Lugar de fabricación
            <v-tooltip bottom>
                <template v-slot:activator="{on}">
                    <v-icon v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>Es la distancia que recorrerá el material desde su fabricación hasta su puesta en obra.</span>
            </v-tooltip>

            <v-icon v-if="fabricacionesCorrectas()" color="green">mdi-check</v-icon>
            <v-icon v-if="!fabricacionesCorrectas()" color="red">mdi-close</v-icon>
        </template>

        <template v-slot:[slot.nombre] v-for="(slot,i) in slots">
            <input-fabricacion-componente v-if="distancias.length > 0"
                                          v-model="slot.correcto"
                                          :key="i"
                                          :distancias="distancias"
                                          :solucion-constructiva="solucionesConstructivas[i]">
            </input-fabricacion-componente>
        </template>

    </dialogo-opciones-componente>
</template>

<script>
    import DialogoOpcionesComponente from "../Componentes/DialogoOpcionesComponente";
    import InputFabricacionComponente from "./Componentes/InputFabricacionComponente";
    import {HttpHelper} from "../../../../../comunes/helpers/HttpHelper";

    export default {
        name: "FabricacionComponente",
        model: {
            prop: 'correctoAmbas',
            event: 'change'
        },
        props: {
            solucionesConstructivas: {type: Array, required: true},
            correctoAmbas: {type: Boolean, default: false}
        },
        components: {
            DialogoOpcionesComponente,
            InputFabricacionComponente
        },
        data: function () {
            return {
                distancias: [],
                slots: [
                    {
                        nombre: "opcion1",
                        correcto: false
                    },
                    {
                        nombre: "opcion2",
                        correcto: false
                    }
                ]
            }
        },
        watch: {
            slots: {
                handler() {
                    this.emitirCorrecto(this.fabricacionesCorrectas());
                },
                deep: true
            }
        },
        mounted() {
            this.cargarDistancias();
            this.emitirCorrecto(this.fabricacionesCorrectas());
        },
        methods: {
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            cargarDistancias() {
                HttpHelper.get('distancias')
                    .then(data => {
                        this.distancias = data;
                    });
            },
            fabricacionesCorrectas() {
                if (!this.slots) return false;
                let correcto = true;
                this.slots.forEach((slot) => {
                    if (!slot.correcto) correcto = false;
                });

                return correcto;
            }
        }
    }
</script>

<style scoped>

</style>